import { ActionType } from '../../constants/ActionTypes';
import config from '../../constants/Configs';
import Utils from '../../services/Utils';
import { RestPath } from '../../constants/SitePaths';
import { Constants } from '../../constants/Constants';
import PopupEnum from '../../components/base/PopupEnum'
import axios from 'axios';
import NotificationService from '../../components/base/notifications/NotificationService'
import { IdentificationEnum, IdentificationFlowEnum } from '../../components/myProfile/profileInfo/Identification/IdentificationEnum';
import { LanguageService } from '../../services/LanguageService';
import { TransactionsHistoryTypeEnum } from '../../components/myProfile/payments/enums/CashierEnum';
import { ErrorHelper } from '../../services/helpers/error/ErrorHelper';


export const registerUserBegin = (data) => ({
    type: ActionType.REGISTER_USER_BEGIN,
    payload: data
});

export const registerUserError = (data) => ({
    type: ActionType.REGISTER_USER_ERROR,
    payload: data
});

export const registerUserSuccess = (data) => ({
    type: ActionType.REGISTER_USER_SUCCESS,
    payload: data
});

export const checkRegisterdDataBegin = () => ({
    type: ActionType.CHECK_REGISTRATION_DATA_BEGIN
});

export const checkRegisterdDataSuccess = () => ({
    type: ActionType.CHECK_REGISTRATION_DATA_SUCCESS
});

export const checkRegisterdDataError = (data) => ({
    type: ActionType.CHECK_REGISTRATION_DATA_ERROR,
    payload: data
});

export const checkRegistrationErrorReset = () => ({
    type: ActionType.CHECK_REGISTRATION_ERROR_RESET
});

export const editProfileBegin = (data) => ({
    type: ActionType.EDIT_PROFILE_BEGIN,
    payload: data
});

export const editProfileError = (data) => ({
    type: ActionType.EDIT_PROFILE_ERROR,
    payload: data
});

export const editProfileSuccess = (data) => ({
    type: ActionType.EDIT_PROFILE_SUCCESS,
    payload: data
});

export const changePlayerData = (data) => ({
    type: ActionType.CHANGE_PLAYER_DATA,
    payload: data
});

export const resetSuccessMessage = () => ({
    type: ActionType.RESET_SUCCESS_MESSAGE
})

export const getDepositsBegin = () => ({
    type: ActionType.GET_DEPOSIT_BEGIN
});

export const getDepositsError = (data) => ({
    type: ActionType.GET_DEPOSIT_ERROR,
    payload: data
});

export const getDepositsSuccess = (data) => ({
    type: ActionType.GET_DEPOSIT_SUCCESS,
    payload: data
});

export const getWithdrawalsBegin = () => ({
    type: ActionType.GET_WITHDRAWALS_BEGIN
});

export const setLoadingState = () => ({
    type: ActionType.SET_LOADING_STATE
});


export const getWithdrawalsError = (data) => ({
    type: ActionType.GET_DITHRAWALS_ERROR,
    payload: data
});

export const getWithdrawalsSuccess = (data) => ({
    type: ActionType.GET_DITHRAWALS_SUCCESS,
    payload: data
});

export const getTournamentsHistoryBegin = (data) => ({
    type: ActionType.GET_BETS_HISTORY_BEGIN,
    payload: data
});

export const getTournamentsHistoryError = (data) => ({
    type: ActionType.GET_BETS_HISTORY_ERROR,
    payload: data
});

export const getTournamentsHistorySuccess = (data) => ({
    type: ActionType.GET_BETS_HISTORY_SUCCESS,
    payload: data
});



export const getReffererReportBegin = () => ({
    type: ActionType.GET_REFERRER_REPORT_BEGIN
});

export const getReffererReportError = (data) => ({
    type: ActionType.GET_REFERRER_REPORT_ERROR,
    payload: data
});

export const getReffererReportSuccess = (data) => ({
    type: ActionType.GET_REFERRER_REPORT_SUCCESS,
    payload: data
});

export const getTransactionsHistoryByTypeBegin = () => ({
    type: ActionType.GET_TRANSACTIONS_HISTORY_BY_TYPE_BEGIN
});

export const getTransactionsHistoryByTypeError = (data) => ({
    type: ActionType.GET_TRANSACTIONS_HISTORY_BY_TYPE_ERROR,
    payload: data
});

export const getTransactionsHistoryByTypeSuccess = (data) => ({
    type: ActionType.GET_TRANSACTIONS_HISTORY_BY_TYPE_SUCCESS,
    payload: data
});

export const cancelWithdrawalNoResetBegin = (data) => ({
    type: ActionType.CANCEL_WITHDRAWAL_BEGIN_NO_RESET,
    payload: data
});

export const cancelWithdrawalBegin = (data) => ({
    type: ActionType.CANCEL_WITHDRAWAL_BEGIN,
    payload: data
});

export const cancelWithdrawalError = (data) => ({
    type: ActionType.CANCEL_WITHDRAWAL_ERROR,
    payload: data
});

export const cancelWithdrawalSuccess = (data) => ({
    type: ActionType.CANCEL_WITHDRAWAL_SUCCESS,
    payload: data
});

export const getBetsHistoryBegin = (data) => ({
    type: ActionType.GET_TOURNAMENTS_HISTORY_BEGIN,
    payload: data
});

export const getBetsHistoryError = (data) => ({
    type: ActionType.GET_TOURNAMENTS_HISTORY_ERROR,
    payload: data
});

export const getBetsHistorySuccess = (data) => ({
    type: ActionType.GET_TOURNAMENTS_HISTORY_SUCCESS,
    payload: data
});

export const resetCalbackStatus = () => ({
    type: ActionType.RESET_CALLBACK_STATUS
});

export const changePopupVisibility = (data) => ({
    type: ActionType.CHANGE_POPUP_VISIBILITY,
    payload: data
})

export const unverifyEmail = () => ({
    type: ActionType.UNVERIFY_ACCOUNT_EMAIL
})
export const unverifyPhoneNumber = () => ({
    type: ActionType.UNVERIFY_ACCOUNT_MOBILE
})
export const unverifyDocumentNumber = () => ({
    type: ActionType.UNVERIFY_DOCUMENT_NUMBER
})
export const setLanguage = (data) => ({
    type: ActionType.SET_LANGUAGE,
    payload: data
})

// Upload document
export const uploadFileBegin = (data) => ({
    type: ActionType.UPLOAD_FILE_BEGIN,
    payload: data
})
export const uploadFileError = (data) => ({
    type: ActionType.UPLOAD_FILE_ERROR,
    payload: data
})
export const uploadFileSuccess = (data) => ({
    type: ActionType.UPLOAD_FILE_SUCCESS,
    payload: data
})

// Upload document
export const getPlayerDocumentStatesBegin = (data) => ({
    type: ActionType.GET_PLAYER_DOCUMENTS_STATES_BEGIN,
    payload: data
})
export const getPlayerDocumentStatesError = (data) => ({
    type: ActionType.GET_PLAYER_DOCUMENTS_STATES_ERROR,
    payload: data
})
export const getPlayerDocumentStatesSuccess = (data) => ({
    type: ActionType.GET_PLAYER_DOCUMENTS_STATES_SUCCESS,
    payload: data
})


// get Kyc documents list
export const getKycBegin = (data) => ({
    type: ActionType.GET_KYC_BEGIN,
    payload: data
})
export const getKycError = (data) => ({
    type: ActionType.GET_KYC_ERROR,
    payload: data
})
export const getKycSuccess = (data) => ({
    type: ActionType.GET_KYC_SUCCESS,
    payload: data
})
export const openOneClickPopup = (data) => ({
    type: ActionType.OPEN_ONE_CLICK_POPUP,
    payload: data
})




// Upload new Kyc document
export const setKycBegin = (data) => ({
    type: ActionType.SET_KYC_BEGIN,
    payload: data
})
export const setKycError = (data) => ({
    type: ActionType.SET_KYC_ERROR,
    payload: data
})
export const setKycSuccess = (data) => ({
    type: ActionType.SET_KYC_SUCCESS,
    payload: data
})



// Get bet history transaction info
export const getTransactionInfoBegin = () => ({
    type: ActionType.GET_TRANSACTION_INFO_BEGIN,
});

export const getTransactionInfoError = (data) => ({
    type: ActionType.GET_TRANSACTION_INFO_ERROR,
    payload: data
});

export const getTransactionInfoSuccess = (id, data) => ({
    type: ActionType.GET_TRANSACTION_INFO_SUCCESS,
    payload: { id, data }
});
// Get payments comissions
export const getPaymentRequestsCommissionBegin = () => ({
    type: ActionType.GET_PAYMENT_REQUESTS_COMMISSIONS_BEGIN,
});

export const getPaymentRequestsCommissionError = (data) => ({
    type: ActionType.GET_PAYMENT_REQUESTS_COMMISSIONS_ERROR,
    payload: data
});

export const getPaymentRequestsCommissionSuccess = (id, data) => ({
    type: ActionType.GET_PAYMENT_REQUESTS_COMMISSIONS_SUCCESS,
    payload: { id, data }
});

export const checkRussianVerificationStatusesBegin = () => ({
    type: ActionType.CHECK_RUSSIAN_VERIFICATION_STATUS_BEGIN,
});

export const checkRussianVerificationStatusesError = (data) => ({
    type: ActionType.CHECK_RUSSIAN_VERIFICATION_STATUS_ERROR,
    payload: data
});

export const checkRussianVerificationStatusesSuccess = (data) => ({
    type: ActionType.CHECK_RUSSIAN_VERIFICATION_STATUS_SUCCESS,
    payload: data
});

export const checkRussianVerificationV2StatusesSuccess = (data) => ({
    type: ActionType.CHECK_RUSSIAN_VERIFICATIONV2_STATUS_SUCCESS,
    payload: data
});



export const getSimpleCupisEsiaBegin = () => ({
    type: ActionType.GET_SIMPLE_CUPIS_ESIA_BEGIN
})

export const getSimpleCupisEsiaError = () => ({
    type: ActionType.GET_SIMPLE_CUPIS_ESIA_ERROR
})


export const getSimpleCupisTinkoffError = () => ({
    type: ActionType.GET_TINKOFF_ERROR
})

export const getCupisTinkoffBegin = () => ({
    type: ActionType.GET_CUPIS_TINKOFF_BEGIN
})


export const getSimpleCupisEsiaSuccess = (data) => ({
    type: ActionType.GET_SIMPLE_CUPIS_ESIA_SUCCESS,
    payload: data
})

export const getCupisTinkoffSuccess = (data) => ({
    type: ActionType.GET_CUPIS_TINKOFF_SUCCESS,
    payload: data
})


export const checkRussianVerificationStatusesV2Begin = () => ({
    type: ActionType.CHECK_RUSSIAN_VERIFICATION_STATUSV2_BEGIN,
})

export const checkRussianVerificationStatusesV2Error = () => ({
    type: ActionType.CHECK_RUSSIAN_VERIFICATION_STATUSV2_ERROR,
})
export const checkRussianVerificationStatusesV2Success = () => ({
    type: ActionType.CHECK_RUSSIAN_VERIFICATION_STATUSV2_SUCCESS,
})

export const confirmRegistrationVerificationCodeBegin = () => ({
    type: ActionType.CONFIRM_REGISTRATION_VERIFICATION_CODE_BEGIN
});

export const confirmRegistrationVerificationCodeError = () => ({
    type: ActionType.CONFIRM_REGISTRATION_VERIFICATION_CODE_ERROR
});

export const getCurrencySpeceficSettingsSuccess = (data) => ({
    type: ActionType.GET_CURRENCY_SPECEFIC_SETTINGS_SUCCESS,
    payload: data
});
export const getNewPlatCurrencySpeceficSettingsSuccess = (data) => ({
    type: ActionType.GET_NEW_PLATCURRENCY_SPECEFIC_SETTINGS_SUCCESS,
    payload: data
});



/* User Registration */
export function registerUser(data) {
    const apiUri = data.firebaseIdToken ? RestPath.FIREBASE_REGISTRATION : RestPath.USER_REGISTRATION;
    return dispatch => {
        const formData = data;
        dispatch(registerUserBegin());

        return axios({
            method: Constants.POST,
            url: config.BASE_URL + apiUri,
            data: data
        }).then((response) => {
            dispatch(registerUserSuccess(response.data));
            return response && response.data;
            // NotificationService.success(response.data);
        }).catch((error) => {
            if (error.response) {
                dispatch(registerUserError(error.response.data));
                NotificationService.error({ message: ErrorHelper.getMessage(error) });
            } else {
                dispatch(registerUserError(error))
                NotificationService.error({ message: LanguageService.getTranslation('genericErrorMsg') });
            }
        });
    };
}

export function oneClickRegisterUser(data) {
    return dispatch => {
        return axios({
            method: Constants.POST,
            url: config.BASE_URL + RestPath.ONE_CLICK_USER_REGISTRATION,
            data: data
        }).then((response) => {
            // if (Browser.isMobileApp()) {
            //     Utils.refreshMobilePage('register')
            // }
            return response && response.data;
        }).catch((error) => {
            if (error.response) {
                NotificationService.error({ message: ErrorHelper.getMessage(error) });
            }
        });
    };
}

export function sendOneClickCredentialsEmail(data) {
    return () => {
        return axios({
            url: config.BASE_URL + RestPath.SEND_ONE_CLICK_CREDENTIALS_EMAIL,
            method: 'POST',
            data
        })
            .then(() => {
                NotificationService.success({ message: LanguageService.getTranslation('oneClickSuccessText', 'registration') });
            })
            .catch((error) => {
                if (error.response) {
                    NotificationService.error({ message: ErrorHelper.getMessage(error) });
                }
            });
    };
}

export function verifyRegistrationData(data) {
    let sendData;
    if (data.countryCode && data.phoneNumber) {
        sendData = {
            ...data,
            mobileNumber: data.phoneNumber.startsWith('+') ? data.phoneNumber.replace(/\s/g, "") : data.countryCode + data.phoneNumber.replace(/\s/g, "")
        }
        delete sendData.countryCode;
        delete sendData.phoneNumber;
    } else {
        sendData = data;
    }
    return dispatch => {
        return axios({
            method: Constants.POST,
            url: config.BASE_URL + RestPath.VERIFY_REGISTRATION_DATA,
            data: sendData
        }).then((response) => {
            return true;
        }).catch((error) => {
            if (error.response) {
                NotificationService.error({ message: ErrorHelper.getMessage(error) });
            }
        })
    };
}


/* Check wizard data validation*/
export function checkRegisterdData(checkedObj) {
    return dispatch => {
        dispatch(checkRegisterdDataBegin());
        return axios({
            method: Constants.POST,
            url: config.BASE_URL + RestPath.CHECK_REGISTRATION_DATA,
            data: checkedObj
        }).then(() => {
            dispatch(checkRegisterdDataSuccess());
            return true;
        }).catch((error) => {
                if (error.response) {
                    dispatch(checkRegisterdDataError(error.response.data));
                    NotificationService.error({ message: ErrorHelper.getMessage(error) });
                } else {
                    dispatch(checkRegisterdDataError(error));
                }
            });
    }
}

export function clearCheckRegisterMessage() {
    return dispatch => {
        dispatch(checkRegistrationErrorReset());
    }
}

/* Edit Profile */
export function editProfile(values, email, mobileNumber, documentNumber, isTwoFA) {
    return dispatch => {
        dispatch(editProfileBegin());
        return axios({
            method: Constants.POST,
            url: config.BASE_URL + RestPath.EDIT_PROFILE,
            data: values
        }).then((response) => {
            dispatch(editProfileSuccess(response.data));

            dispatch(changePlayerData(values));
            if (values.email && values.email !== email) {
                dispatch(unverifyEmail());
            }

            if (values.mobileNumber && values.mobileNumber !== mobileNumber) {
                dispatch(unverifyPhoneNumber());
            }
            if (values.documentNumber && values.documentNumber !== documentNumber) {
                dispatch(unverifyDocumentNumber());
            }

            !isTwoFA && NotificationService.success({ message: response.data.message });
            return true;
        })
            .catch((error) => {
                if (error.response) {
                    dispatch(editProfileError(error.response.data));
                    NotificationService.error({ message: ErrorHelper.getMessage(error) });
                } else {
                    dispatch(editProfileError(error));
                }
            });
    };
}

export function getDeposits(data, bKeepResults) {
    return dispatch => {
        bKeepResults ? dispatch(setLoadingState()) : dispatch(getDepositsBegin());

        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_DEPOSITS,
            params: data
        }).then((response) => {
            dispatch(getDepositsSuccess(response.data));
            return response.data;
        })
            .catch((error) => {
                if (error.response) {
                    dispatch(getDepositsError(error.response.data));
                } else {
                    dispatch(getDepositsError(error));
                }

            });
    };
}

export function getWithdrawals(data, bKeepResults) {
    return dispatch => {
        bKeepResults ? dispatch(setLoadingState()) : dispatch(getWithdrawalsBegin());

        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_WITHDRAWALS,
            params: data
        }).then((response) => {
            dispatch(getWithdrawalsSuccess(response.data));
        })
            .catch((error) => {
                if (error.response) {
                    dispatch(getWithdrawalsError(error.response.data));
                } else {
                    dispatch(getWithdrawalsError(error));
                }

            });
    };
}

export function getTournamentsHistory() {
    return dispatch => {
        dispatch(getTournamentsHistoryBegin());

        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_TOURNAMENTS_HISTORY
        }).then((response) => {
            dispatch(getTournamentsHistorySuccess(response.data));
        })
            .catch((error) => {
                if (error.response) {
                    dispatch(getTournamentsHistoryError(error.response.data));
                } else {
                    dispatch(getTournamentsHistoryError(error));
                }

            });
    };
}

export function getTransactionsHistoryByType(type, data, bKeepResults) {
    let api = '';
    switch (type) {
        case TransactionsHistoryTypeEnum.BalanceAdjustment:
            api = RestPath.GET_BALANCE_ADJUSTMENTS_HISTORY;
            break;
        case TransactionsHistoryTypeEnum.ReferrerHistory:
            api = RestPath.GET_REFERRER_HISTORY;
            break;
        case TransactionsHistoryTypeEnum.SportJackpot:
            api = RestPath.GET_SPORT_JACKPOT_HISTORY;
            break;
        case TransactionsHistoryTypeEnum.Cashback:
            api = RestPath.GET_CASHBACK_HISTORY;
            break;
        case TransactionsHistoryTypeEnum.Bonuses:
            api = RestPath.GET_TRANSACTION_BONUSES_HISTORY;
            break;
        case TransactionsHistoryTypeEnum.BuyActivation:
            api = RestPath.GET_BUY_ACTIVATION_HISTORY;
            break;
        case TransactionsHistoryTypeEnum.CasinoJackpot:
            api = RestPath.GET_CASINO_JACKPOT_HISTORY;
            break;
        case TransactionsHistoryTypeEnum.CasinoTax:
            api = RestPath.GET_CASINO_TAX_HISTORY;
            break;       
        default:
            break;
    }

    return dispatch => {
        bKeepResults ? dispatch(setLoadingState()) : dispatch(getTransactionsHistoryByTypeBegin());
        return axios({
            method: Constants.GET,
            url: config.BASE_URL + api,
            params: data
        }).then((response) => {
            dispatch(getTransactionsHistoryByTypeSuccess(response.data));
        })
            .catch((error) => {
                if (error.response) {
                    dispatch(getTransactionsHistoryByTypeError(error.response.data));
                } else {
                    dispatch(getTransactionsHistoryByTypeError(error));
                }

            });
    };
}



export function getReferrerReport(data, bKeepResults) {
    return dispatch => {
        bKeepResults ? dispatch(setLoadingState()) : dispatch(getReffererReportBegin());
        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_REFERRER_REPORT,
            params: data
        }).then((response) => {
            dispatch(getReffererReportSuccess(response.data));
        })
            .catch((error) => {
                if (error.response) {
                    dispatch(getReffererReportError(error.response.data));
                } else {
                    dispatch(getReffererReportError(error));
                }

            });


    };
}
export function cancelWithdrawal(id, bKeepResults) {
    return dispatch => {
        bKeepResults ? dispatch(cancelWithdrawalNoResetBegin()) : dispatch(cancelWithdrawalBegin());
        return axios({
            method: Constants.POST,
            url: config.BASE_URL + RestPath.CANCEL_WITHDRAWAL + `?RequestId=${id}`
        }).then((response) => {
            dispatch(cancelWithdrawalSuccess(response.data));
        })
            .catch((error) => {
                if (error.response) {
                    dispatch(cancelWithdrawalError(error.response.data));
                } else {
                    dispatch(cancelWithdrawalError(error));
                }

            });

    };
}
export function confirmDeposit(id) {
    return dispatch => {

        return axios({
            method: Constants.POST,
            url: config.BASE_URL + RestPath.CONFIRM_DEPOSIT + `?transactionId=${id}`
        }).then((response) => {
            return response.data
        }).catch((error) => {
            NotificationService.error({ message: ErrorHelper.getMessage(error) });
        });
    };
}


export function getBetsHistory(data) {
    return dispatch => {
        dispatch(getBetsHistoryBegin());

        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_BETS_HISTORY + Utils.objectToQueryParamsWithModel(data, 'request'),
        }).then((response) => {
            dispatch(getBetsHistorySuccess(response.data));
        })
            .catch((error) => {
                if (error.response) {
                    dispatch(getBetsHistoryError(error.response.data));
                } else {
                    dispatch(getBetsHistoryError(error));
                }

            });
    };
}



export function uploadFile(values) {
    return dispatch => {
        const file = values.body.target.files[0];
        const subject = values.subject.value;
        dispatch(uploadFileBegin());
        const formData = new FormData();
        formData.append('File', file);
        formData.append('DocumentType', subject);

        return axios({
            method: Constants.POST,
            url: config.BASE_URL + RestPath.UPLOAD_FILE,
            data: formData
        }).then((response) => {
            dispatch(uploadFileSuccess(response.data));
            NotificationService.success({ message: response.data.message });
            return true;
        })
            .catch((error) => {
                if (error.response) {
                    dispatch(uploadFileError(error.response.data));
                    NotificationService.error({ message: ErrorHelper.getMessage(error) });
                } else {
                    dispatch(uploadFileError(error));
                }
            });

    };
}

export function getPlayerDocumentStates() {
    return dispatch => {
        dispatch(getPlayerDocumentStatesBegin());
        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_PLAYER_DOCUMENT_STATES
        }).then((response) => {
            dispatch(getPlayerDocumentStatesSuccess(response.data));
            return true;
        })
            .catch((error) => {
                if (error.response) {
                    dispatch(getPlayerDocumentStatesError(error.response.data));
                } else {
                    dispatch(getPlayerDocumentStatesError(error));
                }
            });

    };
}

export function getKyc() {
    return dispatch => {
        dispatch(getKycBegin());

        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.KYC
        }).then((response) => {
            dispatch(getKycSuccess(response.data));
            return true;
        })
            .catch((error) => {
                if (error.response) {
                    dispatch(getKycError(error.response.data));
                    NotificationService.error({ message: ErrorHelper.getMessage(error) });
                } else {
                    dispatch(getKycError(error));
                }
            });

    };
}


export function legalAgreement(data) {
    return dispatch => {
        return axios({
            method: Constants.POST,
            url: config.BASE_URL + RestPath.LegalAgreement,
            data
        }).then((response) => {
            dispatch(setKycSuccess(response.data));
            return true;
        })
    }
}



export function setKyc(values) {
    return dispatch => {
        dispatch(setKycBegin());
        const formData = new FormData();
        values.files.map(item => item && formData.append('Files', item))
        formData.append('type', values.section);
        formData.append('option', values.title);
        formData.append('description', values.description);
        return axios({
            method: Constants.POST,
            url: config.BASE_URL + RestPath.KYC,
            data: formData
        }).then((response) => {
            dispatch(setKycSuccess(response.data));
            return true;
        })
            .catch((error) => {
                if (error.response) {
                    dispatch(setKycError(error.response.data));
                } else {
                    dispatch(setKycError(error));
                }
                NotificationService.error({ message: ErrorHelper.getMessage(error) });
            });

    };
}

export function getTransactionInfo(data) {
    return dispatch => {
        dispatch(getTransactionInfoBegin());
        return axios({
            method: Constants.GET,
            url: `${config.BASE_URL}${RestPath.GET_TRANSACTION_INFO}`,
            params: data
        }).then((response) => {
            dispatch(getTransactionInfoSuccess(data.id, response.data));
        })
            .catch((error) => {
                if (error.response) {
                    dispatch(getTransactionInfoError(error.response.data));
                } else {
                    dispatch(getTransactionInfoError(error));
                }

            });
    };
}
export function getPaymentRequestsCommission(data) {
    return dispatch => {
        dispatch(getPaymentRequestsCommissionBegin());
        return axios({
            method: Constants.GET,
            url: `${config.BASE_URL}${RestPath.GET_PAYMENT_REQUESTS_COMMISSIONS}`,
            params: data
        }).then((response) => {
            dispatch(getPaymentRequestsCommissionSuccess(data.paymentRequestId, response.data));
        })
            .catch((error) => {
                if (error.response) {
                    dispatch(getPaymentRequestsCommissionError(error.response.data));
                } else {
                    dispatch(getPaymentRequestsCommissionError(error));
                }

            });
    };
}

export function sendRegistrationVerificationCode(data, isLoginVerification) {
    return dispatch => {
        return axios({
            url: config.BASE_URL + (isLoginVerification ? RestPath.SEND_LOGIN_VERIFICATION_CODE
                : RestPath.SEND_REGISTRATION_VERIFICATION_CODE),
            method: 'POST',
            data
        })
            .then(response => {
                NotificationService.success({ message: response.data.message });
            })
            .catch((error) => {
                NotificationService.error({ message: ErrorHelper.getMessage(error) });
                return true
            });
    };
}

export function confirmRegistrationVerificationCode(data, errorMessage) {
    return dispatch => {
        dispatch(confirmRegistrationVerificationCodeBegin());
        return axios({
            url: config.BASE_URL + RestPath.CONFIRM_REGISTRATION_VERIFICATION_CODE,
            method: 'POST',
            data
        }).then(response => {
            if (response.data) {
                // NotificationService.success({ message: response.data.message });
            } else {
                NotificationService.error({ message: errorMessage });
                dispatch(confirmRegistrationVerificationCodeError());
            }
            return response && response.data;
        }).catch((error) => {
            NotificationService.error({ message: ErrorHelper.getMessage(error) });

        });
    };
}
export function checkRussianVerificationStatuses() {
    return dispatch => {
        dispatch(checkRussianVerificationStatusesBegin());
        return axios({
            method: Constants.GET,
            url: `${config.BASE_URL}${RestPath.CHECK_CLIENT_CUPIS_STATUS}`
        }).then((response) => {
            dispatch(checkRussianVerificationStatusesSuccess(response && response.data && response.data.data));
            return response && response.data && response.data.data
        }).catch((error) => {
            if (error.response) {
                dispatch(checkRussianVerificationStatusesError(error.response.data));
            } else {
                dispatch(checkRussianVerificationStatusesError(error));
            }

        });
    };
}

export function checkRussianVerificationStatusesV2(noLoading) {
    return dispatch => {
        !noLoading && dispatch(checkRussianVerificationStatusesBegin());
        return axios({
            method: Constants.GET,
            url: `${config.BASE_URL}${RestPath.CHECK_CLIENT_CUPIS_STATUSV2}`
        }).then((response) => {
            dispatch(checkRussianVerificationV2StatusesSuccess(response && response.data && response.data.data));
            if (response?.data?.data?.ShowIdentificationForm === IdentificationFlowEnum.OTP) { // && isCashier
                dispatch(changePopupVisibility(PopupEnum.CupisOTP));
            }
            return response && response.data && response.data.data
        }).catch((error) => {
            if (error.response) {
                dispatch(checkRussianVerificationStatusesError(error.response.data));
            } else {
                dispatch(checkRussianVerificationStatusesError(error));
            }

        });
    };
}


export function getCupisTinkoff() {
    return dispatch => {
        dispatch(getCupisTinkoffBegin());

        return axios({
            method: Constants.GET,
            url: `${config.BASE_URL}${RestPath.VERIFY_CUPIS_TINKOFF}`
        }).then((response) => {
            dispatch(getCupisTinkoffSuccess(response && response.data && response.data.data));
            return response && response.data && response.data.data
        }).catch((error) => {
            dispatch(getSimpleCupisTinkoffError());

        })
    };

}
export function getSimpleCupisEsia() {
    return dispatch => {
        dispatch(getSimpleCupisEsiaBegin());
        return axios({
            method: Constants.GET,
            url: `${config.BASE_URL}${RestPath.GET_SIMPLE_CUPIS_ESIA}`
        }).then((response) => {
            dispatch(getSimpleCupisEsiaSuccess(response && response.data && response.data.data));
            return response && response.data && response.data.data
        })
            .catch((error) => {
                dispatch(getSimpleCupisEsiaError());

            })
    };
}

export function getSimpleCupisVerification() {
    return dispatch => {
        dispatch(getSimpleCupisEsiaBegin());
        return axios({
            method: Constants.GET,
            url: `${config.BASE_URL}${RestPath.GET_SIMPLE_VERIFICATION_URL}`
        }).then((response) => {
            dispatch(getSimpleCupisEsiaSuccess(response && response.data && response.data.data));
            return response && response.data && response.data.data
        })
            .catch((error) => {
                error?.response?.data?.message && NotificationService.error({ message: error?.response?.data?.message });

                dispatch(getSimpleCupisEsiaError());
            })
    };
}

export function verifyClientCupisPSP(params) {
    return dispatch => {
        return axios({
            url: config.BASE_URL + RestPath.VERIFY_CUPIS_PSP,
            method: 'GET',
            params
        })
            .then(response => {
                if (!response.data) {
                    NotificationService.error({ message: LanguageService.getTranslation('genericErrorMsg') });
                }
                return response && response.data;
            })
            .catch((error) => {
                NotificationService.error({ message: ErrorHelper.getMessage(error) });
            });
    };
}

export function identifyCupisV2(data, api) {
    return dispatch => {
        return axios({
            url: config.BASE_URL + api,
            method: 'POST',
            data
        }).then(response => {
            if (!response.data) {
                NotificationService.error({ message: LanguageService.getTranslation('genericErrorMsg') });
            }
            return response && response.data;
        })
            .catch((error) => {
                NotificationService.error({ message: ErrorHelper.getMessage(error) });
            });
    };
}

export function identifyCupisClient(data, check) {
    return dispatch => {
        return axios({
            url: config.BASE_URL + check,
            method: 'POST',
            data
        }).then(response => {
            if (check === IdentificationEnum.EDIT_CUPIS_CLIENT_BIRTHDATE && !response.data?.data) {
                NotificationService.error({ message: LanguageService.getTranslation('wrongIdentificationBirthdate', 'account') });
                return;
            }
            if (!response.data) {
                NotificationService.error({ message: LanguageService.getTranslation('genericErrorMsg') });
            }
            return response && response.data;
        }).catch((error) => {
            NotificationService.error({ message: ErrorHelper.getMessage(error) });
        });
    };
}

export function getSessionHistory() {
    return dispatch => {
        return axios({
            url: config.BASE_URL + RestPath.SESSION_HISTORY,
            method: 'GET',
        }).then(response => {
            return response && response.data;
        })
        // .catch((error) => {
        //     NotificationService.error({ message: ErrorHelper.getMessage(error) })
        // });
    };
}

export function quitSessions(value) {
    return dispatch => {
        return axios({
            url: config.BASE_URL + RestPath.QUIT_SESSIONS,
            method: 'POST',
            data: value
        }).then(response => {
            return response && response.data;
        }).catch((error) => {
            // NotificationService.error({ message: ErrorHelper.getMessage(error) })
        });
    };
}

export function getLogHistory() {
    return dispatch => {
        return axios({
            url: config.BASE_URL + RestPath.LOG_HISTORY,
            method: 'GET',
        })
            .then(response => {
                return response && response.data;
            })
        // .catch((error) => {
        //     NotificationService.error({ message: ErrorHelper.getMessage(error) })
        // });
    };
}

export function getCurrencySpeceficSettings(currency) {
    return dispatch => {
        if (config.NEW_PLAT) {
            dispatch(getNewPlatCurrencySpeceficSettingsSuccess(currency));
            return;
        }
        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_CURRENCY_SPECEFIC_SETTINGS
        }).then((response) => {
            dispatch(getCurrencySpeceficSettingsSuccess(response.data));
        })
    };
}